import { render, staticRenderFns } from "./RegistrationLookupComponent.vue?vue&type=template&id=60520542"
import script from "./RegistrationLookupComponent.vue?vue&type=script&lang=js"
export * from "./RegistrationLookupComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports